export default __webpack_public_path__ + "static/media/redbullcom-logo.35bb21ea.svg";